import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteShipmentBookmark } from '@/features/auth'

export const useShipmentBookmarkDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteShipmentBookmark,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['getShipmentBookmarks'],
      })
    },
  })
}
